import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ProfileState {
	defaultBranchId: string
	defaultBranchName: string
	defaultContractId: string
	defaultContractName: string
	defaultCustomerId: string
	defaultCustomerName: string
	setDefaultBranch: (branchId: string, branchName: string) => void
	setDefaultContract: (contractId: string, contractName: string) => void
	setDefaultCustomer: (customerId: string, customerName: string) => void
}

export const useProfileStore = create<ProfileState>()(
	persist(
		(set) => ({
			defaultBranchId: '',
			defaultBranchName: '',
			defaultContractId: '',
			defaultContractName: '',
			defaultCustomerId: '',
			defaultCustomerName: '',
			setDefaultBranch: (branchId, branchName) =>
				set({ defaultBranchId: branchId, defaultBranchName: branchName }),
			setDefaultContract: (contractId, contractName) =>
				set({
					defaultContractId: contractId,
					defaultContractName: contractName,
				}),
			setDefaultCustomer: (customerId, customerName) =>
				set({
					defaultCustomerId: customerId,
					defaultCustomerName: customerName,
				}),
		}),
		{
			name: 'ssma-profile-settings',
		},
	),
)
